import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "esports_apex_legends_e1eb5",
  "use": "esports_apex_legends_e1eb5-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 80 80\" id=\"esports_apex_legends_e1eb5\">\n    <path d=\"M40 3l38 64.151L66.823 76 45.504 61.624h12.37L40 30.651 22.184 61.624h12.235L13.177 76 2 67.151 40 3z\" fill=\"#EA473B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol